
import React, {useState, useEffect} from 'react';
import SVG from "react-inlinesvg";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../_redux/pending-action/pendingActionsHandlers";
import ErrorMessage from './ErrorMessage';


const UploadDocument = ({show, action: {action, error, actedOn, data}, onHide}) => {
    // PendingActions Redux state
    const dispatch = useDispatch();

    /* Get Document File */
    const document = useSelector(({pendingActions}) => pendingActions.document);

    /* Loading Image State */
    const [imageLoaded, setImageLoaded] = useState(false);


    /* Fetch Document */
    useEffect(() => {
        dispatch(handlers.fetchDocument(data?.document));
        return _ => setImageLoaded(false)
    }, [dispatch, data.document]);

    return <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/files/jpg.svg")}
                    />
                </span> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body 
                className="px-10 py-2"
            >   
                <ErrorMessage {...{error}} />
                <div className="text-center py-10" >
                    <div className={`spinner-border mx-5 text-primary ${imageLoaded ? "d-none" : ""}`} style={{width: "4rem", height: "4rem", borderWidth: "0.1rem"}} role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <img src={document} alt={data?.type ?? ""} onLoad={_ => setImageLoaded(true)} className={`img-fluid ${imageLoaded ? "" : "d-none"}`} />
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">User</h6>
                        <span className="text-muted">
                            <NavLink to={`/users/view/${data.meta?.userId}`} target="_blank" >
                                {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </NavLink>
                        </span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Category</h6>
                        <span className="text-muted">{data?.type?.replace(/_/g, " ")}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">ID Type</h6>
                        <span className="text-muted">{data?.idType}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">ID Value</h6>
                        <span className="text-muted">{data?.idValue}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default UploadDocument;